module.exports = __webpack_public_path__ + "img/kf.90429457.jpg";